import { gql } from '@apollo/client'

/** Whether a new campaign may use one campaign budget with optional spend limits per ad set, and the ad account minimum. */
export const CAMPAIGN_BUDGET_OPTIONS = gql`
    query CampaignBudgetOptions($campaignId: String!, $publisherId: String!, $objective: CampaignObjective!) {
        AdCampaign {
            campaignBudgetOptions(campaignId: $campaignId, publisherId: $publisherId, objective: $objective) {
                available
                reason
                message
                min_daily_budget
                bid_strategy
            }
        }
    }
`
